import React, { useEffect, useState } from "react";
import SubLeftMenu from "../AnalyticsModule/SubLeft";
import { useEnableScanningMutation, useGetScannedCompleteDataQuery} from "../../services/announceElection";
import Button from "../../library/components/Button";
import ConfirmationModal from "../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import CustomModal from "../../library/components/Modal/modal";

const ScanningCompleted = () => {

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [getac,setacNo] = useState()
  const [switchTabs, setswitchTabs] = useState("AC");
  const {data:getScannedData,refetch, isSuccess, isError, isLoading}=useGetScannedCompleteDataQuery(switchTabs)
  const [enableScanning,datap] = useEnableScanningMutation()
 
  useEffect(()=>{
    if(datap.isSuccess){
      setShowConfirmationPopup(false)
      refetch()
    }
  },[datap.isSuccess])

  const updateDetails=(e)=>{
    setShowConfirmationPopup(true)
    var temp = e?.target?.name
    setacNo(temp)
  }

  const switchTab = (data, e) => {
    console.log(data)
    setswitchTabs(data);
  };

  return (
    <SubLeftMenu>
      <CustomModal
        className="confirmation_modal"
        show={showConfirmationPopup}
        onClose={() => {
          setShowConfirmationPopup(false);
        }}
        size="500px"
        closeIcon={false}
        modalTitle={"Do you want to Enable Scanning ?"}
        children={
          <div>
            <ConfirmationModal
              // title="You want to delete this"
              noOption={() => {
                setShowConfirmationPopup(false);
              }}
              yesOption={() => {
                enableScanning({
                  "constType": switchTabs,
                  "constNo": getac,
                })
              }}
            />
          </div>
        }
      />
      <div className="container box shadow ">
      <div className="checkboxHeader">
        <p className="text-center checkboxHead">
          Assembly Constituency List With PreCounting Completed
        </p>
      </div>
      <div className="row checkboxHeaderButton">
        <div className="col-md-6" style={{ paddingLeft: "0px" }}>
          <p
            className={`text-center ${
              switchTabs === "AC" ? `checkboxChecked` : `checkboxUnChecked`
            }`}
            onClick={(e) => {
              switchTab("AC", e);
            }}
          >
            Assembly Constituency
          </p>
        </div>
        <div className="col-md-6" style={{ paddingRight: "0px" }}>
          <p
            className={`text-center ${
              switchTabs === "PC" ? `checkboxChecked` : `checkboxUnChecked`
            }`}
            onClick={() => {
              switchTab("PC");
            }}
          >
            Parliamentary Constituency
          </p>
        </div>
      </div>
      <div className="my-4">
      {isLoading ? (
        <p>Loading...</p>
      ) : isError ? (
        <p>No data Found.</p>
      ) : isSuccess ? (
      <table id="customers">
          <thead>
            <tr>
              <th>{switchTabs === "AC" ? "Assembly Constituency No" : "Parliamentary Constituency No"}</th>
              <th>{switchTabs === "AC" ? "Assembly Constituency Name" : "Parliamentary Constituency Name"}</th>
              <th>Action</th>
            </tr>
          </thead>
      {
        getScannedData?.payload?.map((item,index)=>{
          return (
          <tbody>
              <tr key={index}>
                <td>{item.constNo}</td>
                <td>{item.constName}</td>
                <td><Button
              btnClass="btn-reset m-auto"
                value="Enable Scanning"
                name = {item?.constNo}
                onClick={(e) => {
                  updateDetails(e);
                }}
              /></td>
              </tr>
          </tbody>
          )
        })
      }
        </table>
      ): null
      }
      </div>
      </div>
    </SubLeftMenu>
  );
};

export default ScanningCompleted;
